import { supersetDashboardsOps } from "../api/operations";
import { entityFactory } from "../hooks/useEntity";
import { ROLE } from "../Auth/useRole";
import { PartialListDto, SupersetDashboardListDto } from "../api/types";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("bi-dashboards-management"),
  endpoint: "superset-dashboards",
  operations: supersetDashboardsOps,
  roleView: [ROLE.BI_DASHBOARD_VIEW, ROLE.BI_DASHBOARD_ADMIN],
  roleAdmin: [ROLE.BI_DASHBOARD_ADMIN],
  baseRoute: "bi-dashboards-management",
  singularName: (t) => t("BI Dashboard Management"),
  name: (t) => t("BI Dashboard Management"),
  disableCache: true,
  infiniteNormalizer: (value: PartialListDto<SupersetDashboardListDto>) => {
    const results = value.results.map((i) => ({
      id: i.id,
      name: i.name + " - " + i.customerName,
      supersetId: i.supersetId,
    }));

    return {
      ...value,
      results,
    };
  },
});

export default conf;
